import BaseAPI from '@/api/base'

function getClientBalance(client_id, cafe_id) {
    return BaseAPI.get(`/clients/balance/${client_id}/${cafe_id}`);
}

function updateClientBalance(balance_id, options) {
    return BaseAPI.post(`/clients/update_balance/${balance_id}`, options);
}

export default {
    getClientBalance,
    updateClientBalance
}